import { MutationTree } from "vuex";
import { ServiceRecordState, ServiceRecord } from "./model";

const mutations: MutationTree<ServiceRecordState> = {
  setServiceRecords(state, serviceRecords: ServiceRecord[]) {
    state.serviceRecords = serviceRecords
  }
}

export default mutations;
